<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Calendario Aste',
      link: '/calendario-aste'
    }, {
      label: form.uuid ? 'Modifica Calendario Asta' : 'Aggiungi nuova Calendario Asta'
    }]"
  />
  
  <form autocomplete="off">
    <InputText
      v-model="form.name"
      :error-fields="errorFields"
      name="name"
      :submitted="submitted"
    >
      Nome
    </InputText>
  
    <DateTimeInput
      v-model="form.startAt"
      :error-fields="errorFields"
      name="startAt"
      :submitted="submitted"
    >
      Data
    </DateTimeInput>
  
    <CategoryInputSelect
      v-model="form.categoryUuid"
      :error-fields="errorFields"
      name="categoryUuid"
      :submitted="submitted"
    >
      Categoria
    </CategoryInputSelect>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>
  
<script setup>
import moment from 'moment';
import { reactive } from "vue";

import CategoryInputSelect from "@/components/form/CategoryInputSelect.vue";
import DateTimeInput from "@/components/form/DateTimeInput.vue";
import InputBoolean from "@/components/form/InputBoolean.vue";
import InputText from "@/components/form/InputText.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";
  
const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});
  
const axios = useAxios();
  
let form = reactive({
  name: "",
  categoryUuid: null,
  startAt: null
});
  
if (props.id) {
  const resp = await axios.get("/auction-calendar/" + props.id);
  form = reactive(resp.data);
}
  
const rules = {
  name: {
    type: "string",
    max: 128,
    required: true,
  },
  categoryUuid: {
    type: "string",
    required: true,
  },
  startAt: {
    type: "date",
    required: true,
  }
};
  
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'auction-calendar', rules, {
  create: 'Calendario Asta creata con successo',
  update: 'Calendario Asta modificata con successo'
}, '/calendario-aste', () => {
  form.name = "";
  form.categoryUuid = null;
  form.startAt = null;
})
  
</script>
  